export default {"src":"/_next/static/media/arbiscan.f6d69f5a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};